import { ComponentDownState, ComponentLoadingStateTableItem } from '../dashboard/views';
import { MobileAccounts } from '../models';
import {
    Account,
    FormTemplate,
    FormTemplates,
    BaseTaskSource,
    User,
    UsersDistributeGroupsAndRoles
} from '../shared/forms';
import { MobileTasksList, SelectUserModal } from '../views';
import { BaseToolbarNavPageLayout } from '../../backbone/shared/views/baseLayoutViews';
import { FastTasks, MediaFieldTask, MobileFollowers, MobileTasks, MobileTask } from './models';
import { ImageFieldView } from '../../backbone/features/mobileForm/imageField/views';
import { SelectAccountModal } from '../../backbone/shared/views/SelectAccountModal';
import { EmptyListMessage } from '../../backbone/shared/views/EmptyListMessage';
import { CordovaPlugins } from '../../shared/CordovaPlugins';
import { isAndroid, isConnected, isIos, isWeb, isWindows } from '../../shared/utils/is';
import {
    actionSheet,
    confirmNotification,
    hideLoadingDialog,
    showOfflineMessage,
    showLoadingDialog,
    showErrorMessage
} from '../../shared/utils/notifications';

export const FastTaskItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_fast_task_item',
    className: 'fast_task_item',
    tagName: 'li',
    model: null, // MobileTask
    fast_tasks_model: null, // FastTasks

    events: {
        'click .fast_task_item a': 'goto_task'
    },

    templateHelpers: function () {
        return {
            show_form_submission_icon: this.model.get('reply').get('type') === 'form_submission'
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    goto_task: function (event) {
        event.preventDefault();

        $f.mobile.nav.show(TaskEditPage, {
            model: this.model,
            fast_tasks_model: this.fast_tasks_model,
            mode: 'temp_edit'
        });
    }
});

export const FastTasksList = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_fast_tasks_list',
    itemView: FastTaskItem,
    className: 'fast_tasks_list',
    tagName: 'ul',
    collection: null, // Tasks
    fast_tasks_model: null, // FastTasks

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        if (!this.collection) {
            throw new Error('Programmer Error: collection required for FastTasksList');
        }
    },

    itemViewOptions: function (model) {
        return {
            fast_tasks_model: this.fast_tasks_model
        };
    }
});

export const AutocompleteItem = Backbone.Marionette.ItemView.extend({
    template: '#tpl_autocomplete_item',
    className: 'autocomplete_item',
    tagName: 'li',
    model: null,

    templateHelpers: function () {
        return {
            title: this.generate_title()
        };
    },

    events: {
        'click .autocomplete_item a': 'on_select'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    on_select: function (event) {
        // implemented per subclass
        event.preventDefault();
        throw new Error('Programmer Error: on_select not implemented');
    },

    generate_title: function () {
        // implemented per subclass
        throw new Error('Programmer Error: generate_title not implemented');
    }
});

export const AutocompleteList = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_autocomplete_list',
    itemView: AutocompleteItem,
    className: 'autocomplete_list',
    tagName: 'ul',
    search_key: null, // string used to seach the collection
    minimum_text_length: 2, // minimum text length to activiate search
    collection_class: null,

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        if (!this.collection_class) {
            throw new Error('Programmer Error: collection class required for AutocompleteList subclass');
        }

        this.collection = new this.collection_class();

        this.setup_collection();
        this.setup_event_listeners();
    },

    onShow: function () {
        if (!this.search_key || this.search_key.length < this.minimum_text_length) {
            $f.mobile.hide_overflow_touchblock();
            return;
        }
        $('.r_form_task_typeahead').removeClass('disabled');
        this.search();
    },

    setup_collection: function () {
        // implemented per subclass
    },

    setup_event_listeners: function () {
        // implemented per subclass
    },

    search: function (query) {
        var this_ = this;
        var search_online = isWeb() || isConnected(); // @note this is ignored by our cache 2.0

        this.collection.typeahead_search(
            this.search_key,
            function (results) {
                if (results.length === 0) {
                    this_.on_no_results();
                }
            },
            search_online
        );
    },

    on_select: function (model) {
        // implemented per subclass
    },

    on_no_results: function () {
        // implemented per subclass
    }
});

export const FormTaskTypeaheadItem = AutocompleteItem.extend({
    model: null, // FormTemplate
    on_select: function (event) {
        event.preventDefault();
        this.trigger('form_template_selected', this.model);
    },

    generate_title: function () {
        return this.model.get('title') || '';
    }
});

export const FormTaskTypeahead = AutocompleteList.extend({
    itemView: FormTaskTypeaheadItem,
    collection_class: FormTemplates,

    setup_collection: function () {
        this.collection.paginator.set({ filter: $f.active_user.is_admin() ? 'all' : 'me' });
    },

    setup_event_listeners: function () {
        this.listenTo(this, 'itemview:form_template_selected', function (itemview, model) {
            this.on_select(model);
        });
    }
});

export const TaskFollower = Backbone.Marionette.ItemView.extend({
    template: '#tpl_task_follower',
    className: 'form-field',
    tagName: 'li',
    model: null, // User

    events: {
        'click .follower_item .df-remove-circle': 'remove_follower'
    },

    templateHelpers: function () {
        return {
            show_remove_follower: $f.active_user.is_submitter() === false,
            title: this.model.get_display_name()
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    remove_follower: function (event) {
        event.preventDefault();

        this.model.collection.remove(this.model);
    }
});

export const TaskFollowers = Backbone.Marionette.CollectionView.extend({
    template: '#tpl_task_followers',
    itemView: TaskFollower,
    className: 'followers_list',
    tagName: 'ul',
    collection: null, // MobileFollowers

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;

        this.listenTo(this.collection, 'remove', function () {
            this.trigger('followers:follower_removed', this_.collection);
        });
    }
});

export const FollowerModal = SelectUserModal.extend({
    collection_class: UsersDistributeGroupsAndRoles,
    allow_multiple: true,
    toolbarnav_title: function () {
        return _t('mobile_tasks_select_followers');
    }
});

export const TasksCreator = BaseToolbarNavPageLayout.extend({
    template: '#tpl_tasks_creator',
    className: 'tasks_creator',
    toolbarnav_center_title: true,
    toolbarnav_show_add_task: false,
    use_transitions: true,
    model: null, // $f.mobile.Models.Task
    fast_tasks_model: null, // FastTasks
    account: null, // Account
    assignee: null, // User
    date_due_naive: null,
    title: null,
    image_files: null,
    mode: 'create', // this could be create, edit and temp_edit
    is_changed: false,

    regions: {
        r_task_images: '.r_task_images',
        r_multi_task_creator_date_picker: '.r_multi_task_creator_date_picker',
        r_multi_task_creator_followers: '.r_multi_task_creator_followers',
        r_form_task_typeahead: '.r_form_task_typeahead'
    },

    events: {
        'click .btn_account': 'select_account',
        'click .btn_user': 'select_user',
        'click .btn_date_due': 'select_date_due',
        'click .btn_done': 'done_clicked',
        'click .clear_title.remove_title': 'clear_title',
        'change .btn_date_due': 'date_changed',
        'keyup .task_title': 'title_keyup'
    },

    templateHelpers: function () {
        return {
            location: this.account ? this.account.get('name') : _t('mobile_common_unassigned'),
            assignee:
                !!this.assignee && this.assignee.get('id')
                    ? this.assignee.get_display_name()
                    : _t('mobile_common_unassigned'),
            date_due_display_str: this.format_date(),
            title: this.title || '',
            show_form_submission_icon: this.model.get('reply').get('type') === 'form_submission',
            placeholder: _t('mobile_tasks_title_placeholder')
        };
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;

        if (this.model) {
            this.model.store();

            this.listenTo(this.model, 'change', function () {
                this_.is_changed = true;
            });

            this.listenTo(this.model.get('title_image_field'), 'change', function () {
                this_.is_changed = true;
                this_.update_buttons_state();
            });
        }

        if (!!this.fast_tasks_model && !!this.fast_tasks_model.get('tasks')) {
            this.listenTo(this.fast_tasks_model.get('tasks'), 'change', function () {
                this_.is_changed = true;
            });
        }

        this._hide_form_task_typeahead();
    },

    onBeforeRender: function () {
        if (this.$el.find('.btn_date_due')) {
            this.$el.find('.btn_date_due').mobiscroll('destroy');
        }
    },

    onRender: function () {
        var this_ = this;

        this.show_image_field();
        this.setup_date_due_selector();
        this.update_buttons_state();

        this.listenTo(this, 'task_creator:defaults_changed', function (defaults) {
            if (!defaults) {
                return;
            }
            this_.date_due_naive = defaults.date_due_naive ? defaults.date_due_naive : this_.date_due_naive;
            this_.account = defaults.account ? defaults.account : this_.account;
            this_.assignee = defaults.assignee ? defaults.assignee : this_.assignee;
        });

        this._on_rerender();
    },

    show_image_field: function () {
        var this_ = this;

        if (this.model.get('reply').get('type') == 'form_submission') {
            // note: @author:halah when task is changed to form_submission, remove images if any
            this.model.get('title_image_field').set('file', []);
            return;
        }

        this.r_task_images.show(
            new ImageFieldView({
                model: this.model.get('title_image_field'),
                task: this.model,
                hide_caption: true,
                on_select: function () {
                    this_.image_files = this_.model.get('title_image_field').get('file');
                    this_._on_images_select();
                }
            })
        );

        this.listenTo(this_.r_task_images.currentView.model, 'change:file', function () {
            this_.is_changed = true;
        });
    },

    _hide_form_task_typeahead: function () {
        this.$el.find('.r_form_task_typeahead').addClass('disabled');
        if (this.r_form_task_typeahead) {
            this.r_form_task_typeahead.close();
        }
        $f.mobile.hide_overflow_touchblock();
    },

    _on_images_select: function () {
        // implemented per subclass
    },

    setup_date_due_selector: function () {
        var date_due = this.get_date_due();
        var default_date = $f.utils.get_utc_date_without_offset(date_due);
        this.$el
            .find('.btn_date_due')
            .mobiscroll()
            .date({
                theme: 'material',
                display: 'bottom',
                defaultValue: default_date,
                max: new Date(new Date().getFullYear() + 10, 11, 31),
                focusOnClose: false,
                dateWheels: 'M D d yy',
                min: moment().startOf('day').toDate()
            });
    },

    select_account: function (event) {
        event.preventDefault();
        var this_ = this;

        // Submitter (who are also location owners) shouldn't be able to edit the account
        if ($f.active_user.is_submitter() && $f.active_user.get('accounts').length !== 0) {
            return false;
        }

        $f.mobile.nav.show_modal(SelectAccountModal, {
            post_on_select: function (account) {
                this_.account = account;
                this_.model.set('account', this_.account);

                this_.trigger('task_creator:defaults_changed', {
                    account: this_.account
                });

                if (this_.account.get('owners').length !== 0) {
                    // @note: @author:halah the owners is just an array of data and the assignee needs to be a user model
                    // so we have to featch over here.
                    this_.update_assignee(this_.account.get('owners').at(0), function () {
                        this_.trigger('task_creator:defaults_changed', {
                            assignee: this_.assignee
                        });
                        this_.model.set('assignee', this_.assignee);
                        this_._select_account();
                        this_._select_user();
                        this_.render();
                    });
                } else {
                    this_._select_account();
                    this_.render();
                }
            }
        });
    },

    _select_account: function () {
        // implemented per subclass
    },

    select_user: function (event) {
        event.preventDefault();
        var this_ = this;

        // Submitter shouldn't be able to edit the assignee
        if ($f.active_user.is_submitter()) {
            return false;
        }

        $f.mobile.nav.show_modal(SelectUserModal, {
            post_on_select: function (assignee) {
                this_.update_assignee(assignee, function () {
                    this_.trigger('task_creator:defaults_changed', {
                        assignee: this_.assignee
                    });
                    this_.model.set('assignee', this_.assignee);
                    this_._select_user();
                    this_.render();
                });
            }
        });
    },

    _select_user: function () {
        // implemented per subclass
    },

    _reset_view: function () {
        this._hide_form_task_typeahead();
        this.model.set({ title: this.title, reply: { type: 'click_done' } });
        this.show_image_field();
    },

    select_date_due: function (event) {
        this.$el.find('.btn_date_due').mobiscroll('show');
        return false;
    },

    clear_title: function (event) {
        event.preventDefault();
        this.title = '';
        this.$el.find('.remove_title').addClass('disabled');

        this._reset_view();
        this.render();
    },

    title_keyup: function (event) {
        var this_ = this;

        this.title = this.$el.find('.task_title').val();
        this.title = this.title.replace(/^\s*\n/gm, '').trim(); // removes blank lines

        this.update_buttons_state();
        this.$el.find('.df-form').addClass('disabled');
        this.$el.find('.task_title').removeClass('form_submission');
        this.$el.find('.r_form_task_typeahead').addClass('disabled');

        this.model.set('title', this.title);
        // @note: @author:Halah when enter/return key is clicked, this triggers a done click
        if (event.keyCode === 13 && !!this.title) {
            event.preventDefault();
            this._reset_view();
            this._set_title();
            this.$el.find('.btn_done').trigger('click');
        }

        this.r_form_task_typeahead.show(
            new FormTaskTypeahead({
                model: this.model.get('reply').get('form_template') || new FormTemplate(),
                search_key: this.title,
                on_select: function (form_template) {
                    // Always replace entire form template model so the reply's change event is fired. This would otherwise be taken care of if these were BaseZenputModels
                    this_.model.get('reply').set({
                        form_template: new FormTemplate({ id: form_template.id, title: form_template.get('title') }),
                        type: 'form_submission'
                    });
                    this_.title = form_template.get('title');
                    this_.model.set('title', form_template.get('title'));
                    this_.$el.find('.task_title').val(form_template.get('title'));
                    this_.r_task_images.close();
                    this_._set_title();
                    this_.render();
                },
                on_no_results: function () {
                    this_._reset_view();
                    this_._set_title();
                }
            })
        );

        this.r_form_task_typeahead.on('show', function () {
            $f.mobile.show_overflow_touchblock($('.overflow_touchblock.typeahead'), function () {
                $f.mobile.hide_overflow_touchblock();
                this_._reset_view();
                this_._set_title();
                this_.update_buttons_state();
                return false;
            });
        });
    },

    _set_title: function () {
        // implemented per subclass
    },

    date_changed: function () {
        var date = this.$el.find('.btn_date_due').mobiscroll('getDate'); // Get date from the date picker
        // date.toLocaleDateString('en-CA') returns 'YYYY-MM-DD' date format and doesn't do TZ conversion
        this.date_due_naive = date.toLocaleDateString('en-CA') + 'T23:59:59.999Z';
        this.trigger('task_creator:defaults_changed', {
            date_due_naive: this.date_due_naive
        });

        this.model.set('date_due_naive', this.date_due_naive);
        this._select_date_due();
        this.render();
    },

    _select_date_due: function () {
        // implemented per subclass
    },

    done_clicked: function (event) {
        event.preventDefault();
        this._on_done_clicked();
    },

    _on_done_clicked: function () {
        // implemented per subclass
    },

    /**
     * Clear all pending file uploads for our pending upload guid. This is used when a user aborts creating
     * Fast Tasks or editing a single task.
     */
    _clear_pending_uploads: function () {
        if (!_.contains(['edit', 'create'], this.mode)) {
            // do not do this for temp_edit (Fast Tasks edit)
            return;
        }

        if (!this.model.id && !this.model.fast_tasks_model && !this.model.fast_tasks_model.id) {
            return; // shouldn't happen? But best to check
        }

        // we have differenet pending upload guids for creating fast tasks vs editing a single task
        $f.mobile.uploads.clear_pending_file_uploads(this.model.id || this.model.fast_tasks_model.id);
    },

    go_back: function () {
        var this_ = this;
        var fast_tasks_length = this.mode !== 'edit' ? this.fast_tasks_model.get('tasks').length : 0;
        var add_button_label =
            (this.mode !== 'create' && this.title) || (this.mode === 'create' && fast_tasks_length > 0);
        var button_label =
            this.mode === 'create'
                ? _t('mobile_tasks_assign_tasks', { count: fast_tasks_length })
                : _t('mobile_message_task_detials_confirm_save_task');
        var text = _t('mobile_message_task_detials_confirm_message');

        if (!this.is_changed) {
            $f.mobile.nav.go_back();
            return;
        }

        if (!isWeb()) {
            var options = {
                title: _t('mobile_message_task_detials_confirm_title'),
                subtitle: text,
                position: [50, 60], // only used for iPad
                addCancelButtonWithLabel: _t('mobile_action_sheet_cancel')
            };

            if (isIos()) {
                if (add_button_label) {
                    options.buttonLabels = [button_label];
                }
                options.addDestructiveButtonWithLabel = _t('mobile_common_button_discard');
                options.destructiveButtonLast = true;
            } else if (isAndroid()) {
                if (add_button_label) {
                    options.buttonLabels = [button_label, _t('mobile_common_button_discard')];
                } else {
                    options.buttonLabels = [_t('mobile_common_button_discard')];
                }
                options.androidTheme = CordovaPlugins().actionsheet.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT;
                options.androidEnableCancelButton = true;
            } else if (isWindows()) {
                if (add_button_label) {
                    options.buttonLabels = [button_label, _t('mobile_common_button_discard')];
                } else {
                    options.buttonLabels = [_t('mobile_common_button_discard')];
                }
            }

            actionSheet(options, function (button_index) {
                if (add_button_label) {
                    if (button_index === 3) {
                        return;
                    } // cancel
                    if (button_index === 1) {
                        // save Task
                        if (this_.mode === 'temp_edit') {
                            this_.$el.find('.btn_done').trigger('click');
                        } else if (this_.mode == 'edit') {
                            this_.$el.find('.btn_save_task').trigger('click');
                        } else {
                            this_.$el.find('.btn_assign_tasks').trigger('click');
                        }
                        return;
                    }

                    this_._clear_pending_uploads();
                    this_._restore_model();
                } else {
                    if (button_index === 2) {
                        return; // cancel
                    }

                    this_._clear_pending_uploads();
                    this_._restore_model(); // disregard
                }
            });

            return;
        }

        confirmNotification(
            text,
            function (success) {
                if (!success) {
                    this_._clear_pending_uploads();
                    this_._restore_model();
                    return;
                }

                if (add_button_label) {
                    if (this_.mode === 'temp_edit') {
                        this_.$el.find('.btn_done').trigger('click');
                    } else if (this_.mode == 'edit') {
                        this_.$el.find('.btn_save_task').trigger('click');
                    } else {
                        this_.$el.find('.btn_assign_tasks').trigger('click');
                    }
                }
                // If 0 tasks or task has no title
                // Remain in the same view and do nothing
            },
            _t('mobile_message_task_detials_confirm_title'),
            add_button_label ? button_label : _t('mobile_common_continue_editing'),
            _t('mobile_common_button_discard')
        );
    },

    _restore_model: function () {
        this.model.restore();
        // Reset any image added to the title_image_field
        this.model.set(
            'title_image_field',
            new MediaFieldTask(
                {
                    id: 1,
                    type: 'image',
                    title: '',
                    value: this.model.get('title_image').toJSON(), // loads the existing image urls into the field.
                    required: false
                },
                {
                    task_or_project: this.model
                }
            ),
            { silent: true }
        );

        $f.mobile.nav.add_options({ model: this.model });
        $f.mobile.nav.go_back();
    },

    /**
     * Returns moment object of the date_due
     *      defaults to three days from now
     */
    get_date_due: function () {
        if (this.date_due_naive) {
            return moment.utc(this.date_due_naive);
        }
        if (this.model.get('date_due')) {
            var date = this.model._get_zoned_time('date_due');
            if (date !== null) {
                return date;
            }
        }
        var three_days_from_now = moment.utc().add(3, 'day').endOf('day');
        return moment(three_days_from_now.toISOString());
    },

    format_date: function () {
        var date = this.get_date_due();
        return date.format('ddd, MMM D, YYYY');
    },

    update_assignee: function (user_data, callback) {
        callback = callback || function () {};
        hideLoadingDialog();

        // @note: @author:halah @jira:PP-77 data coming from users typeahead is UserDistributeGroupAndRole
        // task assignee is of type User therefore fetch the selected user
        if (!user_data) {
            return;
        }

        this.assignee = new User({
            id: $f.active_user.is_submitter()
                ? $f.active_user.get('id')
                : user_data.get('raw_id') || user_data.get('id')
        });

        this.assignee.fetch({
            success: function () {
                callback();
            },
            error: function (err) {
                callback();
            }
        });
    },

    _on_rerender: function () {
        // implemented per subclass
    },

    update_buttons_state: function () {
        var image_files = this.model.get('title_image_field').get('file');

        if (this.title) {
            this.$el.find('.btn_done').removeClass('grayed_out');
            this.$el.find('.btn_done').removeClass('disabled');
            this.$el.find('.remove_title').removeClass('disabled');
        } else {
            this.$el.find('.remove_title').addClass('disabled');

            if (!image_files) {
                this.$el.find('.btn_done').addClass('disabled');
            } else if (image_files && image_files.length === 0) {
                this.$el.find('.btn_done').removeClass('grayed_out');
                this.$el.find('.btn_done').addClass('disabled');
            } else {
                this.$el.find('.btn_done').removeClass('disabled');
                this.$el.find('.btn_done').addClass('grayed_out');
            }
        }
    }
});

// @todo: @author:halah this is used for temp_edit and edit mode, when more features are added that differeniate between
// the two, separate them to different views to handle differences
export const TaskEditPage = TasksCreator.extend({
    template: '#tpl_task_edit_page',
    followers: null,
    toolbarnav_title: function () {
        return _t('mobile_tasks_toolbarnav_title_edit_task');
    },

    regions: function () {
        return $.extend({}, TasksCreator.prototype.regions, {
            r_followers_list: '.r_followers_list'
        });
    },

    events: $.extend(
        {
            'change .description_watched_input': 'update_description',
            'click .btn_add_followers': 'show_followers',
            'click .btn_delete_task': 'delete_task',
            'click .btn_save_task': 'save_task'
        },
        TasksCreator.prototype.events
    ),

    templateHelpers: function () {
        return $.extend({}, TaskEditPage.__super__.templateHelpers.apply(this, arguments), {
            show_delete: this.mode === 'temp_edit',
            show_followers_title: !!this.followers && this.followers.length > 0,
            placeholder_description: _t('mobile_task_placeholder_description'),
            followers_title: _t('mobile_tasks_followers'),
            add_followers: _t('mobile_tasks_add_followers'),
            show_add_followers: !$f.active_user.is_submitter()
        });
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        this.mode = options.mode;
        this.account = this.model.get('account');
        this.assignee = this.model.get('assignee');
        this.date_due = this.model.get('date_due');
        this.title = this.model.get('title');

        if (!!this.model.get('followers') && this.model.get('followers').length > 0) {
            this.followers = this.model.get('followers');
            return;
        }

        this.followers = new MobileFollowers();

        TaskEditPage.__super__.initialize.apply(this, arguments);
    },

    _on_rerender: function () {
        var this_ = this;
        var followers_list = new TaskFollowers({ collection: this.followers });

        this.r_followers_list.show(followers_list);
        this.listenTo(followers_list, 'followers:follower_removed', function (followers) {
            this_.followers = followers;
            this_.model.set('followers', this_.followers);
            this_.render();
        });
    },

    update_buttons_state: function () {
        if (this.mode === 'temp_edit') {
            TaskEditPage.__super__.update_buttons_state.apply(this, arguments);
            return;
        }

        this.$el.find('.btn_done').addClass('disabled');

        if (this.title) {
            this.$el.find('.btn_save_task').removeClass('disabled');
            this.$el.find('.remove_title').removeClass('disabled');
        } else {
            this.$el.find('.btn_save_task').addClass('disabled');
            this.$el.find('.remove_title').addClass('disabled');
        }
    },

    _on_done_clicked: function () {
        if (this.mode === 'temp_edit') {
            this.title = '';
            this.image_files = null;

            $f.mobile.nav.go_back();
            return;
        }
    },

    update_description: function (event) {
        var target = $(event.target);
        this.model.set('description', target.val());
    },

    show_followers: function (event) {
        event.preventDefault();
        var this_ = this;

        var followers = this_.followers
            ? this_.followers.convert_to_user_distributed()
            : new UsersDistributeGroupsAndRoles();

        $f.mobile.nav.show_modal(FollowerModal, {
            collection: followers,
            default_selections: followers,
            post_on_select: function (followers_list) {
                this_.followers = new MobileFollowers();
                // @Note: @author:halah @jira:PP-77 we conver here because every item from followers modal
                // is UsersDistributeGroupsAndRoles but followers collection expects a User
                followers_list.each(function (follower) {
                    this_.followers.push({ id: follower.get('raw_id'), display_name: follower.get('name') });
                });

                this_.model.set('followers', this_.followers);
                this_.render();
            }
        });
    },

    delete_task: function (event) {
        event.preventDefault();

        var this_ = this;
        var text = _t('mobile_message_task_detials_confirm_message');
        var button_title_delete = _t('mobile_drafts_button_delete');
        var button_title_save = _t('mobile_message_task_detials_confirm_save_task');

        if (this.mode !== 'temp_edit') {
            return;
        }

        if (!isWeb()) {
            var options = {
                title: _t('mobile_message_task_detials_confirm_title'),
                subtitle: text,
                position: [50, 60], // only used for iPad
                addCancelButtonWithLabel: _t('mobile_action_sheet_cancel')
            };
            // note: @author:halah only show save task button if there is a title on the task
            if (isIos()) {
                if (this.title) {
                    options.buttonLabels = [button_title_save];
                }
                options.addDestructiveButtonWithLabel = button_title_delete;
                options.destructiveButtonLast = true;
            } else if (isAndroid()) {
                if (this.title) {
                    options.buttonLabels = [button_title_save, button_title_delete];
                } else {
                    options.buttonLabels = [button_title_delete];
                }
                options.androidTheme = CordovaPlugins().actionsheet.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT;
                options.androidEnableCancelButton = true;
            } else if (isWindows()) {
                if (this.title) {
                    options.buttonLabels = [button_title_save, button_title_delete];
                } else {
                    options.buttonLabels = [button_title_delete];
                }
            }

            actionSheet(options, function (button_index) {
                if (!this_.title) {
                    if (button_index === 2) {
                        return;
                    } // cancel
                    this_._delete_task();
                } else {
                    if (button_index === 3) {
                        return;
                    } // cancel
                    if (button_index === 1) {
                        // save Task
                        this_.$el.find('.btn_done').trigger('click');
                        return;
                    }

                    this_._delete_task();
                }
            });

            return;
        }

        confirmNotification(
            text,
            function (success) {
                if (!success) {
                    this_._delete_task();
                    return;
                }
                if (this_.title) {
                    this_.$el.find('.btn_done').trigger('click');
                }
                // If task has no title
                // Remain in same view
            },
            _t('mobile_message_task_detials_confirm_title'),
            this.title ? button_title_save : _t('mobile_common_continue_editing'),
            button_title_delete
        );
    },

    save_task: function (event) {
        event.preventDefault();
        var this_ = this;

        this.$el.find('.btn_save_task').addClass('disabled');
        showLoadingDialog();

        $f.mobile.new_tasks.get_pending_task(this_.model.id, function (task) {
            if (task) {
                showErrorMessage(_t('mobile_task_edition_already_in_progress'), true);
                return;
            }
            // Add task to $f.mobile.new_tasks
            $f.mobile.new_tasks.add_records(
                this_.model,
                function () {
                    this_.$el.find('.btn_save_task').removeClass('disabled');
                    hideLoadingDialog();

                    $f.mobile.nav.add_options({ model: this_.model });

                    // update cache with the new edits
                    this_.model.persist_updates_to_caches(function () {
                        $f.mobile.nav.go_back();

                        // When editing, we want to check that no edits are pending on the task before allowing another
                        $f.mobile.uploads.start_upload({
                            msg: _t('mobile_task_task_updated'),
                            error_msg: _t('mobile_task_error_updating_task'),
                            success: function () {
                                this_.model.set('is_edit_mode', false); // update edit mode when done
                            }
                        });
                    });
                },
                function () {
                    this_.$el.find('.btn_save_task').removeClass('disabled');
                    hideLoadingDialog();

                    showErrorMessage(_t('mobile_task_error_updating_task'), true);
                }
            );
        });

        return;
    },

    _delete_task: function () {
        this.fast_tasks_model.get('tasks').remove(this.model);
        $f.mobile.nav.go_back();
    }
});

export const FastTasksPage = TasksCreator.extend({
    template: '#tpl_fast_tasks_page',
    mode: 'create',

    toolbarnav_title: function () {
        return _t('mobile_tasks_create_task');
    },

    regions: function () {
        return $.extend({}, TasksCreator.prototype.regions, {
            r_fast_tasks_list: '.r_fast_tasks_list'
        });
    },

    events: $.extend(
        {
            'click .btn_assign_tasks': 'assign_tasks'
        },
        TasksCreator.prototype.events
    ),

    templateHelpers: function () {
        return $.extend({}, FastTasksPage.__super__.templateHelpers.apply(this, arguments), {
            assign_task_title:
                this.mode === 'create'
                    ? _t('mobile_tasks_assign_tasks', { count: this.fast_tasks_model.get('tasks').length })
                    : ''
        });
    },

    initialize: function (options) {
        var this_ = this;
        options = options || {};
        $.extend(this, options);

        if (!this.fast_tasks_model) {
            this.fast_tasks_model = new FastTasks();
            this.fast_tasks_model.set('tasks', new MobileTasks(), { silent: true });
        }

        this.init_task_model();

        FastTasksPage.__super__.initialize.apply(this, arguments);

        if (!this.date_due_naive) {
            var three_days_from_now = moment.utc().add(3, 'day').endOf('day');
            this.date_due_naive = three_days_from_now.toISOString();
        }

        this.listenTo(this.fast_tasks_model.get('tasks'), 'add remove reset', function () {
            this_.init_task_model();
            this_.render();
        });
    },

    _on_rerender: function () {
        var this_ = this;

        this.model.set(
            {
                account: this.account,
                assignee: this.assignee,
                date_due_naive: this.date_due_naive,
                title: this.title
            },
            {
                silent: true
            }
        );

        if (this.image_files) {
            this.model.get('title_image_field').set('file', this.image_files, { silent: true });
            this.show_image_field();
        }

        this.r_fast_tasks_list.show(
            new FastTasksList({
                collection: this.fast_tasks_model.get('tasks'),
                fast_tasks_model: this.fast_tasks_model
            })
        );

        if (this.fast_tasks_model && this.fast_tasks_model.get('tasks').length > 0) {
            this.$el.find('.btn_assign_tasks').removeClass('disabled');
        } else {
            this.$el.find('.btn_assign_tasks').addClass('disabled');
        }

        if (!this.account && !this.assignee) {
            showLoadingDialog();
            this.fetch_accounts(
                function (accounts) {
                    var user_accounts = $f.active_user.get('accounts');
                    // Ensure for submitters who are location owners, the tasks default account is one they have access to
                    if ($f.active_user.is_submitter()) {
                        if (user_accounts && user_accounts.length !== 0) {
                            this_.account = accounts.findWhere({ id: user_accounts[0].id });
                        }

                        this_.update_assignee($f.active_user, function () {
                            $f.mobile.nav.add_options({ assignee: this_.assignee });
                            this_.render();
                        });

                        return;
                    }

                    if (accounts.length === 0) {
                        hideLoadingDialog();
                        return;
                    }

                    this_.account = accounts.at(0);

                    $f.mobile.nav.add_options({ account: this_.account });

                    if (this_.account.get('owners').length !== 0) {
                        // @note: @author:halah the owners is just an array of data and the assignee needs to be a user model
                        // so we have to featch over here.
                        this_.update_assignee(this_.account.get('owners').at(0), function () {
                            $f.mobile.nav.add_options({ assignee: this_.assignee });
                            this_.render();
                        });
                    } else {
                        hideLoadingDialog();
                        this_.render();
                    }
                },
                function (error) {
                    hideLoadingDialog();
                }
            );
        }
        // note: @author:halah as long as we have tasks created on edit mode, the user should be prompted to confirm
        // on go_back
        if (
            !!this.fast_tasks_model &&
            this.fast_tasks_model.get('tasks') &&
            this.fast_tasks_model.get('tasks').length > 0
        ) {
            this.is_changed = true;
        }
    },

    onDomRefresh: function () {
        var this_ = this;

        setTimeout(function () {
            if (!this_.title) {
                this_.$el.find('.task_title').focus();
            }
        }, 500);
    },

    init_task_model: function () {
        this.model = new MobileTask(
            {
                reply: { type: 'click_done' },
                assignee: this.assignee,
                account: this.account,
                date_due_naive: this.date_due_naive,
                source: new BaseTaskSource({ type: 'mobile' }) // indicates the task is being created from the mobile app
            },
            {
                fast_tasks_model: this.fast_tasks_model
            }
        );

        $f.mobile.nav.add_options({ model: this.model, fast_tasks_model: this.fast_tasks_model }); // when we come back, send us back our model
    },

    _on_done_clicked: function () {
        var this_ = this;

        this.trigger('task_creator:defaults_changed', {
            assignee: this_.assignee,
            account: this_.account,
            date_due_naive: this_.date_due_naive
        });

        this.title = '';
        this.image_files = null;
        // remove values for title and images so they won't stick for subsequent tasks
        $f.mobile.nav.add_options({ title: '', image_files: null });
        // @note: @author:halah @jira:MOBILE-684
        // Tasks added during the creation interaction will be ordered by the most recently created at the top
        this.fast_tasks_model.get('tasks').unshift(this.model);
    },

    _select_account: function () {
        $f.mobile.nav.add_options({ account: this.account });
    },

    _select_user: function () {
        $f.mobile.nav.add_options({ assignee: this.assignee });
    },

    _select_date_due: function () {
        $f.mobile.nav.add_options({ date_due_naive: this.date_due_naive });
    },

    _set_title: function () {
        $f.mobile.nav.add_options({ title: this.title });
    },

    _on_images_select: function () {
        $f.mobile.nav.add_options({ image_files: this.image_files });
    },

    assign_tasks: function (event) {
        event.preventDefault();
        var this_ = this;

        showLoadingDialog();

        $f.mobile.fast_tasks.add_records(
            this_.fast_tasks_model,
            function () {
                hideLoadingDialog();

                $f.mobile.nav.add_options({ fast_tasks_model: this_.fast_tasks_model });
                $f.mobile.nav.go_back();

                $f.mobile.uploads.start_upload(
                    {
                        error_msg: _t('mobile_common_message_task_creator_error_save'),
                        msg: _t('mobile_message_task_detials_wait_submit_task_created')
                    },
                    true
                );
            },
            function () {
                hideLoadingDialog();
                showErrorMessage(_t('mobile_common_message_task_creator_error_save'), true);
            }
        );
    },

    fetch_accounts: function (success, erorr) {
        success = success || function () {};
        erorr = erorr || function () {};

        var accounts = new MobileAccounts();
        accounts.fetch({
            success: function () {
                success(accounts);
            },
            error: function (err) {
                erorr(err);
            }
        });
    }
});

export const TasksBucketSeeMore = Backbone.Marionette.ItemView.extend({
    template: '#tpl_tasks_bucket_see_more',
    tagName: 'a',
    className: 'tasks_bucket_see_more',
    collection: null, // MobileTasks

    attributes: {
        href: '#'
    },

    events: {
        click: 'fetch_more'
    },

    fetch_more: function () {
        if (this.$el.hasClass('disabled')) {
            return false;
        }

        this._disable_button();
        const success = () => this._enable_button();
        const error = () => {
            this._enable_button();

            if (!isConnected()) {
                showOfflineMessage();
            }
        };
        this.collection.fetch_more_for_bucket(success, error);

        return false;
    },

    _disable_button: function () {
        this.$el.addClass('disabled');
    },

    _enable_button: function () {
        this.$el.removeClass('disabled');
    }
});

export const TasksBucketSet = Backbone.Marionette.Layout.extend({
    template: '#tpl_tasks_bucket_set',

    search_options: null, // TaskSearchOptions variant
    tasks_collection_class: null, // @see TasksPage
    account_id: null, // account ID to filter by if any
    task_bucket_collections: null, // {}

    regions: {
        r_tasks_overdue: '.r_tasks_overdue',
        r_today_tasks: '.r_today_tasks',
        r_week_tasks: '.r_week_tasks',
        r_outside_week_tasks: '.r_outside_week_tasks',
        r_project_tasks_incomplete: '.r_project_tasks_incomplete',
        r_project_tasks_complete: '.r_project_tasks_complete',
        r_project_tasks_archived_incomplete: '.r_project_tasks_archived_incomplete'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
        var this_ = this;

        this.listenTo($f.application.vent, 'dashboard:tasks:rerender_tasks', function () {
            this_.search_options.fetch_from_local(function () {
                this_.task_bucket_collections = {};
                this_._show_buckets();
            });
        });
    },

    onRender: function () {
        if (this._isShown) {
            this._on_show_render();
        }
    },

    onShow: function () {
        this._on_show_render();
    },

    /**
     * Runs only on show and successive renders (not on render before show)
     *
     * @todo:marionette_showrender @jira:INF-559
     */
    _on_show_render: function () {
        this._show_buckets();
    },

    _show_buckets: function () {
        var project_search_options = this.search_options.findWhere({ field: 'project_ids' });
        var project_id = project_search_options ? project_search_options.get('value') : null;

        if (project_id) {
            this._show_task_buckets_for_project(this.search_options);
        } else {
            this._show_task_buckets(this.search_options);
        }
    },

    _show_task_buckets: function () {
        var status = this.search_options.get_value_for_field('status');
        var is_filter_status_open = status !== 'closed' && status !== 'completed_late';
        var is_filter_status_archived = status === 'archived_incomplete';
        var group_by = this.search_options.get_value_for_field('group_by');
        var is_filter_group_by_location = group_by === 'account';
        if (is_filter_status_open && !is_filter_status_archived) {
            this.r_tasks_overdue.show(
                new TasksBucket({
                    bucket_title: _t('mobile_tasks_toolbarnav_header_overdue'),
                    collection: this._get_collection_for_overdue(this.search_options),
                    show_count: true,
                    should_hide_when_empty: true,
                    no_fetch: !this._should_show_overdue_card(this.search_options),
                    empty_view_i18n_key: 'mobile_empty_list_message_no_tasks_overdue'
                })
            );
        }

        var today_tasks_title;
        var show_count = false;
        var type_word;

        const type = this.search_options.get_value_for_field('type');

        const typeWords = {
            tasks: _t('mobile_common_tasks'),
            follow_up_actions: _t('mobile_tso_type_follow_up_actions'),
            all: _t('mobile_tso_type_all')
        };

        type_word = typeWords[type] ?? typeWords.all;

        if (!is_filter_status_open) {
            today_tasks_title = _t('mobile_tasks_bucket_completed_today');
        } else if (is_filter_status_archived) {
            today_tasks_title = _t('mobile_tasks_bucket_missed_today');
        } else {
            today_tasks_title = _t('mobile_tasks_bucket_due_next_24_hours');
            show_count = true;
        }

        this.r_today_tasks.show(
            new TasksBucket({
                bucket_title: today_tasks_title,
                show_count: show_count,
                collection: this._get_collection_for_today_tasks(this.search_options),
                always_display_time: true
            })
        );

        if (!is_filter_group_by_location) {
            var week_tasks_title;
            if (!is_filter_status_open) {
                week_tasks_title = _t('mobile_tasks_bucket_completed_this_week');
            } else if (is_filter_status_archived) {
                week_tasks_title = _t('mobile_tasks_bucket_missed_this_week');
            } else {
                week_tasks_title = _t('mobile_tasks_bucket_due_next_7_days');
            }
            this.r_week_tasks.show(
                new TasksBucket({
                    bucket_title: week_tasks_title,
                    collection: this._get_collection_for_week(this.search_options),
                    is_collapsed: true
                })
            );
        }

        if (!is_filter_group_by_location) {
            var outside_week_tasks_title;
            if (!is_filter_status_open) {
                outside_week_tasks_title = _t('mobile_tasks_bucket_completed_last_week');
            } else if (is_filter_status_archived) {
                outside_week_tasks_title = _t('mobile_tasks_bucket_missed_last_week');
            } else {
                outside_week_tasks_title = _t('mobile_tasks_bucket_open_tasks', { type: type_word });
            }
            this.r_outside_week_tasks.show(
                new TasksBucket({
                    bucket_title: outside_week_tasks_title,
                    collection: this._get_collection_for_outside_this_week(this.search_options),
                    is_collapsed: true
                })
            );
        }
    },

    _show_task_buckets_for_project: function () {
        var status_filter = this.search_options.findWhere({ field: 'status' }).get('value') || 'all';

        if (status_filter === 'all' || status_filter === 'open') {
            this.r_project_tasks_incomplete.show(
                new TasksBucket({
                    bucket_title: _t('mobile_tso_filter_incomplete'),
                    collection: this._get_collection_for_project_tasks_incomplete(this.search_options)
                })
            );
        }

        if (status_filter === 'all' || status_filter === 'closed') {
            this.r_project_tasks_complete.show(
                new TasksBucket({
                    bucket_title: _t('mobile_tso_filter_completed'),
                    collection: this._get_collection_for_project_tasks_complete(this.search_options)
                })
            );
        }

        if (status_filter === 'all' || status_filter === 'archived_incomplete') {
            this.r_project_tasks_archived_incomplete.show(
                new TasksBucket({
                    bucket_title: _t('mobile_task_status_title_incomplete_and_closed'),
                    collection: this._get_collection_for_project_tasks_archived_incomplete(this.search_options)
                })
            );
        }
    },

    _should_show_overdue_card: function () {
        var status = this.search_options.get_value_for_field('status');
        return status !== 'closed';
    },

    _get_collection_for_overdue: function (search_options) {
        var LIMIT = 3;

        if (this.task_bucket_collections.overdue) {
            return this.task_bucket_collections.overdue;
        }

        this.task_bucket_collections.overdue = this.tasks_collection_class.create_collection_for_overdue_bucket(
            search_options,
            {
                limit: LIMIT,
                account_id: this.account_id
            }
        );

        return this.task_bucket_collections.overdue;
    },

    _get_collection_for_today_tasks: function (search_options) {
        if (this.task_bucket_collections.today) {
            return this.task_bucket_collections.today;
        }

        this.task_bucket_collections.today = this.tasks_collection_class.create_collection_for_today_bucket(
            search_options,
            { account_id: this.account_id }
        );

        return this.task_bucket_collections.today;
    },

    _get_collection_for_week: function (search_options) {
        if (this.task_bucket_collections.week) {
            return this.task_bucket_collections.week;
        }

        this.task_bucket_collections.week = this.tasks_collection_class.create_collection_for_week_bucket(
            search_options,
            { account_id: this.account_id }
        );

        return this.task_bucket_collections.week;
    },

    _get_collection_for_outside_this_week: function (search_options) {
        if (this.task_bucket_collections.outside_this_week) {
            return this.task_bucket_collections.outside_this_week;
        }

        this.task_bucket_collections.outside_this_week =
            this.tasks_collection_class.create_collection_outside_this_week_bucket(search_options, {
                account_id: this.account_id
            });

        return this.task_bucket_collections.outside_this_week;
    },

    _get_collection_for_project_tasks_complete: function (search_options) {
        if (this.task_bucket_collections.complete) {
            return this.task_bucket_collections.complete;
        }

        this.task_bucket_collections.complete =
            this.tasks_collection_class.create_collection_for_project_tasks_complete(search_options, {
                account_id: this.account_id
            });

        return this.task_bucket_collections.complete;
    },

    _get_collection_for_project_tasks_incomplete: function (search_options) {
        if (this.task_bucket_collections.incomplete) {
            return this.task_bucket_collections.incomplete;
        }

        this.task_bucket_collections.incomplete =
            this.tasks_collection_class.create_collection_for_project_tasks_incomplete(search_options, {
                account_id: this.account_id
            });

        return this.task_bucket_collections.incomplete;
    },

    _get_collection_for_project_tasks_archived_incomplete: function (search_options) {
        if (this.task_bucket_collections.archived_incomplete) {
            return this.task_bucket_collections.archived_incomplete;
        }

        this.task_bucket_collections.archived_incomplete =
            this.tasks_collection_class.create_collection_for_project_tasks_archived_incomplete(search_options, {
                account_id: this.account_id
            });

        return this.task_bucket_collections.archived_incomplete;
    }
});

export const TasksBucket = Backbone.Marionette.Layout.extend({
    template: '#tpl_tasks_bucket',
    className: 'dashboard_card card sticky_header',
    collection: null, // MobileTasks
    bucket_title: null,
    no_fetch: false, // if true, we won't fetch the collection. Useful in cases where we want to show an empty bucket
    show_count: false,
    empty_view_i18n_key: null,
    always_display_time: false, // If true when displaying the task always show the time.
    should_hide_when_empty: false,
    is_collapsed: false, // colappsed buckets also don't fetch collections until opened

    regions: {
        r_body: '.r_body',
        r_tasks_bucket_see_more: '.r_tasks_bucket_see_more'
    },

    templateHelpers: function () {
        return {
            bucket_title: this.bucket_title,
            show_header: this.bucket_title,
            show_count: this.show_count,
            results_count: this._get_results_count_display(),
            is_collapsed: this.is_collapsed
        };
    },

    events: {
        'click .dashboard_card_header': 'toggle_task_bucket'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        var this_ = this;

        if (this_.is_collapsed) {
            $f.mobile.tasks.buckets_collapsed_states[this._get_collapsed_state_id()] = true;
        }

        // remove see_more button when length reaches expected count
        this.listenTo(this.collection, 'sync', function () {
            this_._show_hide_see_more_button();
            this_._update_header_count();
            this_._show_tasks_list();
        });

        this.listenTo(this.collection, 'error', function () {
            if (isConnected()) {
                this_._show_error_state();
            }
        });
    },

    onBeforeRender: function () {
        // if we don't close this before rendering, it will stay alive orphaned without a parent and not attached to the DOM
        this.r_tasks_bucket_see_more.close();
    },

    onRender: function () {
        if (this._isShown) {
            this._on_show_render();
        }
    },

    onShow: function () {
        this._on_show_render();
    },

    /**
     * Runs only on show and successive renders (not on render before show)
     *
     * @todo:marionette_showrender @jira:INF-559
     */
    _on_show_render: function () {
        this._watch_for_visible();
        this._show_loading_state();
        this._show_hide_see_more_button();
    },

    onClose: function () {
        this._get_$page_scrollable().off(this._get_scroll_event_name());
    },

    _should_fetch: function () {
        return !this.no_fetch && !this.collection.is_fetched && !this.is_collapsed;
    },

    _watch_for_visible: function () {
        var this_ = this;

        // if prioritizing cached results, load results immediately so we can restore the scroll position if necessary
        if ($f.utils.is_element_in_viewport(this.$el) || !this_._should_fetch()) {
            this_._perform_initial_fetch();
            return;
        }

        this._get_$page_scrollable().on(this._get_scroll_event_name(), function () {
            if (!$f.utils.is_element_in_viewport(this_.$el)) {
                return;
            }

            this_._get_$page_scrollable().off(this_._get_scroll_event_name());
            this_._perform_initial_fetch();
        });
    },

    _get_$page_scrollable: function () {
        if (!this.$el.parents('.page_scrollable').length) {
            throw new Error('page_scrollable element not found');
        }
        return this.$el.parents('.page_scrollable');
    },

    _show_tasks_list: function () {
        this.r_body.show(
            new MobileTasksList({
                collection: this.collection,
                empty_view_i18n_key: this.empty_view_i18n_key,
                always_display_time: this.always_display_time
            })
        );
        if (this.collection.length === 0 && this.should_hide_when_empty) {
            this.$el.hide();
        } else {
            this.$el.show();
        }
    },

    _get_scroll_event_name: function () {
        return 'scroll.tasks_bucket_' + this.cid;
    },

    _perform_initial_fetch: function () {
        if (this._should_fetch()) {
            this.collection.fetch();
        }
    },

    _show_loading_state: function () {
        if (this.collection.is_fetching && isConnected()) {
            this.r_body.show(new ComponentLoadingStateTableItem());
        } else {
            this._show_tasks_list();
        }
    },

    _show_error_state: function () {
        var this_ = this;

        this.r_body.show(new ComponentDownState());
        this.r_tasks_bucket_see_more.close();
        this.listenToOnce(this.r_body.currentView, 'downstate_retry', function () {
            this_.collection.fetch();
        });
    },

    _show_hide_see_more_button: function () {
        if (!this._should_show_see_more()) {
            this.r_tasks_bucket_see_more.close();
        } else if (!this.r_tasks_bucket_see_more.currentView) {
            this.r_tasks_bucket_see_more.show(
                new TasksBucketSeeMore({
                    collection: this.collection
                })
            );
        }
    },

    _should_show_see_more: function () {
        return (
            this.collection.paginator.get('results_count') !== undefined &&
            this.collection.length !== this.collection.paginator.get('results_count') &&
            this.collection.length > 0
        );
    },

    _get_results_count_display: function () {
        return this.collection.paginator.get('results_count') || '';
    },

    _update_header_count: function () {
        if (!this.show_count) {
            return;
        }

        this.$el.find('.tasks_bucket_count').html(this._get_results_count_display());
    },

    toggle_task_bucket: function () {
        const newTaskState = !this.is_collapsed;

        this.is_collapsed = newTaskState;
        $f.mobile.tasks.buckets_collapsed_states[this._get_collapsed_state_id()] = newTaskState;
        this.render();
        return false;
    },

    _get_collapsed_state_id: function () {
        return this.collection.get_cache_key();
    }
});

export const TasksAccountBucket = Backbone.Marionette.Layout.extend({
    template: '#tpl_tasks_account_bucket',
    className: 'tasks_account_bucket',
    model: Account,

    search_options: null, // TaskSearchOptions variant
    tasks_collection_class: null, // @see TasksPage
    task_bucket_collections: null, // {}

    regions: {
        r_account_bucket_body: '.r_account_bucket_body'
    },

    templateHelpers: function () {
        return {
            is_collapsed: $f.mobile.tasks.location_buckets_collapsed_states[this._get_collapsed_state_id()]
        };
    },

    events: {
        'click .account_bucket_header': 'toggle_tasks_account_bucket'
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    },

    onRender: function () {
        if (this._isShown) {
            this._on_show_render();
        }
    },

    onShow: function () {
        this._on_show_render();
    },

    /**
     * Runs only on show and successive renders (not on render before show)
     *
     * @todo:marionette_showrender @jira:INF-559
     */
    _on_show_render: function () {
        var account_id = this.model.id;
        var key = `account-${account_id}`;

        this.task_bucket_collections[key] = this.task_bucket_collections[key] || {};

        this.r_account_bucket_body.show(
            new TasksBucketSet({
                search_options: this.search_options,
                tasks_collection_class: this.tasks_collection_class,
                account_id: account_id,
                task_bucket_collections: this.task_bucket_collections[key]
            })
        );
    },

    toggle_tasks_account_bucket: function () {
        var is_collapsed = $f.mobile.tasks.location_buckets_collapsed_states[this._get_collapsed_state_id()];
        $f.mobile.tasks.location_buckets_collapsed_states[this._get_collapsed_state_id()] = !is_collapsed;
        this.render();
        return false;
    },

    _get_collapsed_state_id: function () {
        var account_id = this.model.id;
        if (!account_id) {
            return null;
        }
        return `account_${account_id}`;
    }
});

export const TasksAccountBucketList = Backbone.Marionette.CollectionView.extend({
    collection: null, // MobileAccounts,
    itemView: TasksAccountBucket,

    search_options: null, // TaskSearchOptions variant
    tasks_collection_class: null, // @see TasksPage
    task_bucket_collections: null, // {}

    itemViewOptions: function () {
        return {
            search_options: this.search_options,
            tasks_collection_class: this.tasks_collection_class,
            task_bucket_collections: this.task_bucket_collections
        };
    },

    getEmptyView: function () {
        return EmptyListMessage.extend({
            icon_class: 'df-location',
            i18n_key_message: 'mobile_empty_list_message_no_accounts'
        });
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);
    }
});
